import { render } from "./FeedbackMenu.vue?vue&type=template&id=0d37b3de"
const script = {}

import "./FeedbackMenu.vue?vue&type=style&index=0&id=0d37b3de&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__